import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TipoDoctoRef } from 'app/shared/inmemory-db/tipo-docto-ref';
import { FatDoctoCCce } from 'app/shared/interfaces/fat-docto-cc-ce';
import { FatDoctoCCService } from 'app/shared/services/fat-docto-cc.service';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';

@Component({
  selector: 'app-lancamento-cc-popup',
  templateUrl: 'lancamento-cc-popup.component.html',
  styleUrls: ['lancamento-cc-popup.component.scss'],
})
export class LancamentoCCPopupComponent implements OnInit, OnDestroy {

  public doctoCCForm: FormGroup;

  cartaCorrecao: FatDoctoCCce;

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoCCPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCCService,
    private snack: MatSnackBar
  ) {
  }

  ngOnInit() {
    this.cartaCorrecao = this.data.payload;
    this.buildForm(this.cartaCorrecao);
  }

  buildForm(cc: FatDoctoCCce) {
    this.doctoCCForm = this.fb.group({
      id: [cc?.id],
      fatDoctoC: [cc?.fatDoctoC],
      ambiente: [cc?.ambiente],
      correcao: [cc?.correcao, [Validators.required]],
      cstatus: [cc?.cstatus],
      dataEmissao: [cc?.dataEmissao],
      log: [cc?.log],
      protocolo: [cc?.protocolo],
      seqEvento: [cc?.seqEvento, [Validators.required]],
      status: [cc?.status],
      xmlAssinado: [cc?.xmlAssinado],
      xmlDistribuicao: [cc?.xmlDistribuicao],
      xmlRetorno: [cc?.xmlRetorno],
      controle: [cc?.controle],
      uuid: [cc?.uuid],
      issueDate: [cc?.issueDate],
      updatedAt: [cc?.updatedAt],
    })

  }

  save() {
    if (this.doctoCCForm.invalid) {
      this.snack.open('Campos obrigatórios não preenchidos, verifique!', 'ERRO', { verticalPosition: 'top', duration: 6500 });
      return;
    }
    console.log('Form', this.doctoCCForm.value);
    this.fatDoctoCService.saveOrUpdateFatDoctoCCce(this.doctoCCForm.value).subscribe(
      (carta) => {
        console.log('Carta Correção Salva', carta);

        this.confirmService.confirm(
          {
            title: `S U C E S S O  !`,
            message: `Atualizado com Sucesso !`,
            error: false
          }
        );
      },
      (err) => {
        this.confirmService.confirm(
          {
            title: `A T E N Ç Ã O !`,
            message: `${err?.error.erro ?? 'Erro ao salvar Carta'}`,
            error: true
          }
        );
      });

  }


  ngOnDestroy() {
  }

  close() {
    this.dialogRef.close();
  }

}
